module.exports = __webpack_public_path__ + "images/home/product/mobile/features-calendar-a24ece38c779dd980cdc299ae9c8ed26.png";